<template>
  <div style="min-height: 92vh">
    <h3>Insumos AYB</h3>
    <v-btn v-if="false" color="green" dark>
      <v-icon>mdi-file-excel-box</v-icon>
      <download-excel type="xls" name="Reporte Existencias" :data="excel_data">
        Exportar a Excel
      </download-excel>
    </v-btn>
    <v-alert v-if="showOnlyNoUso" border="top" color="warning" dark>
      Se muestran insumos sin usar en recetas
    </v-alert>
    <uv-data-table :config="config" :data="global_prod" :pageRows="15" @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"></uv-data-table>
    <modal v-model="showModal" :showFooter="false" title="Insumos">
      <ProductosForm :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </ProductosForm>
    </modal>

    <modal v-model="showModalPrecio" :showFooter="false" title="Modificar Costo">
      <h3>Costos del insumo {{ editableCosto.Nombre }}</h3>
      <template v-for="(cost, Costindex) in editableCosto.Costeo">
        <v-row :key="Costindex">
          <v-col>{{ cost.depto }}</v-col>
          <v-col>
            <v-text-field v-model="cost.cto.C" @keypress="$pgsHelper.onlyNumber($event, cost.cto.C)"
              :label="'Costo (' + editableCosto.Extra.AYB.UM + ')'"></v-text-field>
          </v-col>
          <v-col><v-btn color="primary" @click="editCostoInsumo(cost.cto.C, cost)">Guardar</v-btn></v-col>
        </v-row>
      </template>
    </modal>
    <modal v-model="showModalPrecioPorcentaje" :showFooter="false" title="Modificar Precios">
      <ProductoPrecioProcentajeForm :edit="editMode" :key="formIndex" @toggle="showModalPrecioPorcentaje = false"
        :dataEdit="editData">
      </ProductoPrecioProcentajeForm>
    </modal>
    <modal v-model="showModalInsumosNoUso" :showFooter="false" title="Insumos sin uso">
      <InsumoNoUso></InsumoNoUso>
    </modal>
    <modal v-model="showModalPrecioPorcentaje" :showFooter="false" title="Modificar Precios">
      <ProductoPrecioProcentajeForm :edit="editMode" :key="formIndex" @toggle="showModalPrecioPorcentaje = false"
        :dataEdit="editData">
      </ProductoPrecioProcentajeForm>
    </modal>
    <modal v-model="showModalPresentaciones" :showFooter="false" title="Presentaciones Productos">
      <ProductosPresentaciones :edit="editMode" :key="formIndex" @toggle="showModalPresentaciones = false"
        :dataEdit="editData" @successData="saveModificadores" />
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ProductosForm from "./InsumosForm.vue";

import ProductoPrecioProcentajeForm from "../../Inventarios/Productos/ProductoPrecioPorcentajeForm.vue";
import ProductosPresentaciones from "./InsumosPresentaciones.vue";
import InsumoNoUso from "./InsumoNoUso.vue";
import { mapActions } from "vuex";
export default {
  name: "InsumosCRUD",
  components: {
    modal,
    uvDataTable,
    ProductosForm,
    ProductoPrecioProcentajeForm,
    ProductosPresentaciones,
    InsumoNoUso,
  },
  props: [],
  data() {
    return {
      showOnlyNoUso: false,
      showModalInsumosNoUso: false,
      editableCosto: [],
      MainDepartamento: "",
      costos: {},
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      familias: [],
      Categories: [],
      editData: [],
      products: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      showModalPrecio: false,
      showModalModificador: false,
      showModalPrecioPorcentaje: false,
      showModalRecetas: false,
      showModalPresentaciones: false,
      zonas: [],
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        allowExport: true,
        rawText: "Insumos",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addProducto",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editProducto",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteProducto",
            require: true,
          },
          {
            text: "Presentaciones",
            icon: "lni lni-package",
            buttonId: "addPresentacion",
            require: true,
          },
          {
            text: "Modificar Costo",
            icon: "lni lni-dollar",
            buttonId: "editCosto",
            require: true,
          },
          {
            text: "Insumos sin uso",
            icon: "lni lni-package",
            buttonId: "insumosSinUso",
            require: false,
          },

          /*
          {
            text: "+/- % Precio",
            icon: "",
            buttonId: "editPrecioMasivo",
            require: false,
          },
          {
            text: "Admin. Modificadores",
            icon: "lni lni-list",
            buttonId: "adminModificadores",
            require: true,
          },*/
          /* {
            text: "Admin. Receta",
            icon: "lni lni-list",
            buttonId: "adminIngredientes",
            require: true,
          },*/
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Unidad",
            value: "Extra",
            format: (row) => {
              let html = row.Extra?.AYB?.UM;

              return html;
            },
            canBeFiltered: true,
          },
          {
            text: "Codigo",
            value: "Codigo",
          },
          {
            text: "Identificador",
            value: "id",
          },
          {
            text: "Tipo",
            value: "Tipo",
          },
          {
            text: "Categoria",
            value: "categoria_name",
            canBeFiltered: true,
          },
          {
            text: "Familia",
            value: "Familia",
            canBeFiltered: true,
          },
          {
            text: "Departamentos",
            value: "Departamentos",
            canBeFiltered: true,
          },
          {
            text: "Existencia",
            value: "existenciaData", //'Existencia',
            format: (row) => {
              //return row["existenciaData"]
              let html = "";
              row["existenciaData"].forEach((element) => {
                html +=
                  "<span>&#8226;</span> " +
                  element.NombreOrigen +
                  ": " +
                  element.Price.Stock +
                  "<br/>";
              });
              return html;
            },
          },
          {
            text: "Costo Promedio",
            value: "Costeo",
            format: (row) => {
              let html = "";
              if (row["Costeo"]) {
                row["Costeo"].forEach((element) => {
                  html +=
                    "<span>&#8226;</span> " +
                    element.depto +
                    ": " +
                    this.$pgsHelper.formatNumber(element.cto.C) +
                    " " +
                    element.cto.M +
                    "<br/>";
                });
              }

              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
          {
            text: "Ultimo Costo",
            value: "CosteoUltimo",
            format: (row) => {
              let html = "";
              if (row["Costeo"]) {
                row["Costeo"].forEach((element) => {
                  html +=
                    "<span>&#8226;</span> " +
                    element.depto +
                    ": " +
                    this.$pgsHelper.formatNumber(element.uct.C) +
                    " " +
                    element.uct.M +
                    "<br/>";
                });
              }

              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addProducto") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editProducto") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editCosto") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        if (this.editData.Costeo) {
          this.editData.Costeo.forEach((item) => {
            item.cto.C = this.$pgsHelper.roundNumber(item.cto.C);
          });
          this.editableCosto = this.editData;
        }

        this.showModalPrecio = true;
      }
      if (buttonId == "deleteProducto") {
        this.deleteProducto(idSelected[0]);
      }
      if (buttonId == "editPrecioMasivo") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.showModalPrecioPorcentaje = true;
      }
      if (buttonId == "addPresentacion") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalPresentaciones = true;
      }
      if (buttonId == "insumosSinUso") {
        this.showOnlyNoUso = !this.showOnlyNoUso
      }
      if (buttonId == "adminIngredientes") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalRecetas = true;
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    successData(data, doAction) {
      data.Precio = parseFloat(data.Precio);
      data.Orden = Number(data.Orden);
      if (doAction == "CREATE") {
        this.addProduct(data);
      } else if (doAction == "EDIT") {
        this.editProduct(data);
      }
    },
    editCostoInsumo(costo, dataRaw) {
      dataRaw.cto.C = Number(dataRaw.cto.C);
      let datos = {
        Id: this.editData.id,
        Departamento: dataRaw.depto,
        Costo: dataRaw.cto,
      };
      this.$alert.alertConfirm({
        action: "editar",
        obj: "el costo del insumo",
        route: "PDV-Productos-changeCostoProducto",
        data: datos,
        onSuccess: () => { },
      });
    },
    async deleteProducto(id) {
      const deletedObject = this.getProductoById(id) || { Id: id };
      let datos = { Id: id };
      this.$alert.alertConfirm({
        action: "eliminar",
        obj: "el insumo",
        route: "PDV-Productos-deleteProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_DELETE",
            Mensaje: "Producto eliminado ",
            reference: { id: id, tp: "AYB-Insumo", al: "Insumo" },
            data: deletedObject
          });
          this.getCategories();
        },
      });
    },
    editProduct(datos) {
      //datos.Departamento      =  this.MainDepartamento;
      this.$alert.alertConfirm({
        action: "editar",
        obj: "el insumo",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_EDIT",
            Mensaje: "Producto editado",
            reference: { id: datos.id, tp: "Insumo", al: "Insumo" },
            data: datos
          });
          this.toggleModal(false);
        },
      });
    },
    addProduct(datos) {
      this.$alert.alertConfirm({
        action: "crear",
        obj: "el insumo",
        route: "PDV-Productos-createProducto",
        data: datos,
        onSuccess: (result) => {
          const targetId = result?.data?.id || result?.data?.data?.id || datos.id;
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_CREATE",
            Mensaje: "Producto creado",
            reference: { id: targetId, tp: "Insumo", al: "Insumo" },
            data: datos
          });
          this.toggleModal(false);
        },
      });
    },
    saveModificadores(datos) {
      this.$alert.alertConfirm({
        action: "actualizar",
        obj: "los modificadores del producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_EDIT",
            Mensaje: "Producto editado",
            reference: { id: datos.id, tp: "Insumo", al: "Insumo" },
            data: datos
          });
          this.showModalModificador = false;
        },
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.zonas = [];
        this.zonas.push({ Id: "TICKET-PRINTER", nomb: "Default" });
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.zonas.push(toAdd);
          }
        });
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.global_prod, { id: code });
      if (itemIndex >= 0) {
        return this.$pgsHelper.cloneObj(this.global_prod[itemIndex]);
      }

      return false;
    },
    async getProducts() { },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let globalCosto = {};
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
  },
  computed: {
    insumosNoUso() {
      let products = {}
      let prod = this.$store.getters.getProductos;
      prod.forEach((element) => {

        if (element.Tipo == "AYB-Insumo" && !element.Dlat) {
          let existInReceta = false

          prod.forEach((item) => {
            if (item._CatIdx) {
              if (item._CatIdx.includes(element.id)) {
                existInReceta = true
              }
            }
          })
          if (!existInReceta) {
            products[element.id] = element
          }
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });
      return products


    },
    excel_data() {
      let dataExcel = [];
      let totales = {};
      let data = this.global_prod;
      /*let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });*/
      return this.global_prod;
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        if (this.getCategoryById(element.Categoria).ZImp) {
          element.ZImp = this.$pgsHelper.getById(
            this.zonas,
            "Id",
            this.getCategoryById(element.Categoria).ZImp
          ).nomb;
        } else {
          element.Zimp = "Default";
        }
        if (element.Tipo == "AYB-Insumo" && !element.Dlat) {
          let Familia = this.getCategoryById(element.Categoria)
            ? this.getCategoryById(element.Categoria).Familia
            : "";
          element.Familia = this.$pgsHelper.getById(
            this.familias,
            "id",
            Familia
          )
            ? this.$pgsHelper.getById(this.familias, "id", Familia).Nombre
            : "";
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });
      productos.forEach((producto) => {
        let invData = [];
        let matchCount = 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          if (origen.Productos[producto.id]) {
            invData.push({
              Origen: origen.Origen,
              ori: origen.id,
              Price: origen.Productos[producto.id],
              Costo: this.$pgsHelper.formatNumber(
                this.costos[producto.id]?.cto?.C || 0
              ),
              NombreOrigen: origen.nombreOrigen,
            });
          }


        });
        producto.Costeo = this.costos[producto.id];
        producto.CosteoUltimo = this.costos[producto.id];
        producto.existenciaPrecio = invData;
        producto.existenciaData = invData;
      });

      let data = productos;
      if (this.showOnlyNoUso) {
        data = productos.filter((ins) => {
          if (this.insumosNoUso[ins.id]) {
            return true
          } else {
            return false
          }
        })
      }
      /*let claims = this.$route.params.user.tokenResult.claims;
      if (claims?.Data?.Only?.AYB) {
        data = JSON.parse(JSON.stringify(productos)).filter((prod) => {
          if (prod.Departamentos && prod.Departamentos.includes('Restaurante')) {
            return true;
          } else {
            return false;
          }
        });
      }*/
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");

      return sortReservations;
    },
  },
  watch: {},
  mounted() { },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getFamilias();
    this.getCategories();
    this.getZonasImpresion();
    this.getCostos();
    //this.getProducts();
  },
};
</script>
